module.exports = __webpack_public_path__ + "img/组 8@2x.2ebcac64.png";